var _path, _path2, _g, _path3, _path4, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3251_164061)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.749 12.9239C25.749 12.895 25.749 12.8664 25.749 12.8375C25.749 5.74773 19.9846 0.000610352 12.874 0.000610352C5.76343 0.000610352 0 5.74723 0 12.837C0 12.8641 0 12.8913 0 12.9187V14.1637C0 21.2532 5.76443 27.0004 12.875 27.0004C19.9856 27.0004 25.749 21.253 25.749 14.1635V12.9239Z",
    fill: "#B96400"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3251_164061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.749 12.9233C25.749 12.8944 25.749 12.8658 25.749 12.8369C25.749 5.74712 19.9846 0 12.874 0C5.76343 0 0 5.74662 0 12.8364C0 12.8635 0 12.8907 0 12.9181V14.1631C0 21.2526 5.76443 26.9998 12.875 26.9998C19.9856 26.9998 25.749 21.2524 25.749 14.1629V12.9233Z",
    fill: "#B96400"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3251_164061)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#CD7814"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8752 22.9623C10.368 22.9581 7.95172 22.0257 6.095 20.3458C4.23828 18.6659 3.07349 16.3584 2.82655 13.8707C2.57961 11.3831 3.26812 8.89267 4.75854 6.88251C6.24897 4.87234 8.43507 3.48573 10.8928 2.99161C13.3506 2.49748 15.9048 2.93108 18.0601 4.20829C20.2153 5.4855 21.818 7.51529 22.5573 9.90396C23.2965 12.2926 23.1196 14.8699 22.0609 17.1359C21.0022 19.4019 19.1372 21.1951 16.8275 22.1677C15.5771 22.6949 14.2329 22.9652 12.8752 22.9623Z",
    fill: "url(#paint0_linear_3251_164061)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8744 3.21198C15.2573 3.21609 17.5538 4.10247 19.3185 5.69919C21.0831 7.29592 22.19 9.48918 22.4246 11.8536C22.6591 14.2179 22.0046 16.5849 20.5879 18.4954C19.1713 20.4058 17.0934 21.7236 14.7574 22.1931C12.4215 22.6626 9.99383 22.2504 7.94544 21.0363C5.89705 19.8223 4.37389 17.893 3.6714 15.6227C2.96892 13.3523 3.13717 10.9028 4.14354 8.74914C5.1499 6.59549 6.92264 4.89125 9.11791 3.96697C10.3064 3.46586 11.584 3.20907 12.8744 3.21198ZM12.8744 2.21072C10.2425 2.21483 7.70595 3.19339 5.75674 4.95659C3.80754 6.7198 2.58461 9.14196 2.32517 11.7533C2.06573 14.3646 2.78827 16.9789 4.35264 19.0891C5.91701 21.1993 8.2117 22.6551 10.7916 23.1739C13.3715 23.6928 16.0528 23.2378 18.3153 21.8972C20.5778 20.5566 22.2602 18.4259 23.0364 15.9186C23.8125 13.4112 23.6269 10.7057 22.5157 8.32703C21.4044 5.94832 19.4467 4.0659 17.0222 3.0449C15.7099 2.49145 14.2992 2.20772 12.8744 2.21072Z",
    fill: "url(#paint1_linear_3251_164061)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8745 2.2107C15.5064 2.21481 18.0429 3.19337 19.9921 4.95657C21.9413 6.71978 23.1642 9.14194 23.4237 11.7532C23.6831 14.3646 22.9606 16.9789 21.3962 19.0891C19.8319 21.1993 17.5372 22.655 14.9573 23.1739C12.3773 23.6927 9.69609 23.2377 7.4336 21.8972C5.1711 20.5566 3.48861 18.4259 2.7125 15.9185C1.93638 13.4111 2.12195 10.7057 3.23321 8.32701C4.34447 5.94831 6.30221 4.06589 8.72669 3.04488C10.0389 2.49139 11.4497 2.20766 12.8745 2.2107ZM12.8745 0C5.76393 0 0 5.74712 0 12.8369C0 19.9267 5.76443 25.6735 12.875 25.6735C19.9856 25.6735 25.749 19.9264 25.749 12.8369C25.749 5.74737 19.9851 0 12.8745 0Z",
    fill: "url(#paint2_linear_3251_164061)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3251_164061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 20V18.5278H8V17.0556H9.5V9.69444H8V8.22222H10.25V6.75H11.75V8.22222H13.25V6.75H14.75V8.31424C15.4 8.486 15.9375 8.83246 16.3625 9.35363C16.7875 9.87528 17 10.4796 17 11.1667C17 11.5225 16.9375 11.8628 16.8125 12.1877C16.6875 12.513 16.5125 12.8045 16.2875 13.0622C16.725 13.3198 17.078 13.6694 17.3465 14.1111C17.6155 14.5528 17.75 15.0435 17.75 15.5833C17.75 16.3931 17.4563 17.0862 16.8688 17.6628C16.2813 18.2395 15.575 18.5278 14.75 18.5278V20H13.25V18.5278H11.75V20H10.25ZM11 12.6389H14C14.4125 12.6389 14.7657 12.4946 15.0598 12.2061C15.3533 11.918 15.5 11.5715 15.5 11.1667C15.5 10.7618 15.3533 10.4151 15.0598 10.1265C14.7657 9.83848 14.4125 9.69444 14 9.69444H11V12.6389ZM11 17.0556H14.75C15.1625 17.0556 15.5157 16.9115 15.8098 16.6235C16.1033 16.3349 16.25 15.9882 16.25 15.5833C16.25 15.1785 16.1033 14.8318 15.8098 14.5432C15.5157 14.2551 15.1625 14.1111 14.75 14.1111H11V17.0556Z",
    fill: "url(#paint3_linear_3251_164061)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3251_164061",
    x: 8,
    y: 6.5,
    width: 9.75,
    height: 13.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.478432 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3251_164061"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3251_164061",
    result: "effect2_dropShadow_3251_164061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3251_164061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3251_164061",
    x1: 12.8752,
    y1: 24.0532,
    x2: 12.8752,
    y2: 3.80234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EBA700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3251_164061",
    x1: 12.8744,
    y1: 2.47118,
    x2: 12.8744,
    y2: 23.7233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C96D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3251_164061",
    x1: 12.8745,
    y1: 25.9337,
    x2: 12.8745,
    y2: 0.260215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFE300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3251_164061",
    x1: 12.875,
    y1: 19.9991,
    x2: 12.875,
    y2: 6.75084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFE300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3251_164061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.75,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.5919974881a79e5b3c3b370835884a7b.svg";
export { ForwardRef as ReactComponent };